import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionsMultiSelectTask extends ConditionRegistryCategory {
    label = 'Multi Select Task';
    constructor(parent) {
        super(parent);
        super.init();
    }
    isLastMultiSelectTask = () => new ConditionRegistryItem({
        label: 'Is Last Multi Select Task',
        eval: ({ multiSelectTask }) => multiSelectTask.question.tasks[multiSelectTask.question.tasks.length - 1] === multiSelectTask,
    });
    gapIsCurrentTaskInRolename = () => new ConditionRegistryItem({
        eval: ({ gap, at, questionMultiSelect }) => {
            const task = getTaskByTag(at, questionMultiSelect);
            return !!task && task === questionMultiSelect.task;
        },
    });
    multiSelectTaskByTagIsComplete = () => new ConditionRegistryItem({
        label: 'Corresponding Task in Rolename is complete',
        eval: ({ at, questionMultiSelect }) => {
            const task = getTaskByTag(at, questionMultiSelect);
            return !!task && task.taskProgress.isTaskComplete;
        },
    });
}
function getTaskByTag(at, questionMultiSelect) {
    const stepName = at.actor.tags.find((role) => role.includes('task'));
    if (!stepName)
        return false;
    const nth = parseInt(stepName.split('task')[1]);
    if (!questionMultiSelect)
        return false;
    if (questionMultiSelect.tasks.length < nth)
        return false;
    const task = questionMultiSelect.tasks[nth - 1];
    if (!task)
        return false;
    return task;
}
